(function($) {

  	// DOM is fully loaded, safe to manipulate elements
  	$(function() {	

		const tSplide = document.querySelectorAll('.trusler-block--testimonials .splide');

		if (tSplide) {

			tSplide.forEach(sliderEl => {

				const splide = new Splide(sliderEl, {
					perPage: 1,
					perMove: 1,
					arrows: true,
					pagination: false,
					autoplay: false,				
					/** 
					 * Autoheight with Splide - pt1
					 *
					 * @url https://codepen.io/mei331/pen/PovbOvE
					 */				
					type: 'slide', 		// doesn't work with 'loop' (slide CLONES!!!) 
					rewind: true, 		// `rewind` is friendlier than forcing the user to 
										// start manually sliding back from the end
					updateOnMove: true, // updates the is-active status of slides just before 
										// moving the carousel
					start: 0, 			// first slide
					/*gap: 'clamp(0px, 4.32vw, 70px)',
					mediaQuery: 'max',
					breakpoints: {
						1024: {
							perPage: 3,
						},
						768: {
							perPage: 2,
						},	
						560: {
							perPage: 1,
						},				
					}*/							
				});

				/** 
				 * Autoheight with Splide - pt2
				 *
				 * @url https://codepen.io/mei331/pen/PovbOvE
				 */
				splide.on( 'mounted', function () {

					const setNum 	= 1,
				    	  slideEle 	= sliderEl.querySelector('.splide__slide:nth-child('+setNum+')'),
				    	  visHeight = slideEle.offsetHeight,
				    	  wrapEle 	= sliderEl.querySelector('.splide__list');

				    wrapEle.style.height = visHeight + 'px';

				});			

				splide.on( 'ready', function () {

					/*setTimeout( function() {

						const slidesArr = sliderEl.querySelectorAll('.inner-wrap--post-item');
					  
						slidesArr.forEach( post => {
							ParcelFunctions.inViewport(post, 0.3, 0.15, 'post-in-viewport');
						})

					}, 1000);*/

				});

				splide.mount();

				/** 
				 * Autoheight with Splide - pt3
				 *
				 * @url https://codepen.io/mei331/pen/PovbOvE
				 */
				splide.on('move', function () {

				    const actEle 	= sliderEl.querySelector('.splide__slide.is-active'),
						  actHeight = actEle.offsetHeight;
				    	  wrapEle 	= sliderEl.querySelector('.splide__list'),
					
					wrapEle.style.height = actHeight + 'px';
				
				});			

			});

		}

		const testBlocksArr = document.querySelectorAll('.trusler-block--testimonials');
		testBlocksArr.forEach(block => {

			ParcelFunctions.inViewport(block, 0.05, 0.15, 'block-in-viewport');

		});	

	});

})(jQuery);